export const CATEGORY_NAME_OFFSET = '56px';

export const DEFAULT_COLUMNS_COUNT = 3;
export const MIN_COLUMNS_COUNT = 1;
export const MAX_COLUMNS_COUNT = 7;
export const INLINE_CLEAR_ICON_MAX_COLUMNS = 4;

export const COLUMN_WIDTH_MAP: Record<number, string> = {
  1: '320px',
  2: '260px',
  3: '200px',
  4: '160px',
  5: '130px',
  6: '107px',
  7: '90px',
};

export const CATEGORY_NAME_WIDTH_MAP: Record<number, string> = {
  1: '250px',
  2: '250px',
  3: '250px',
  4: '210px',
  5: '180px',
  6: '180px',
  7: '180px',
};

export const SERVICE_NAME_WIDTH_MAP: Record<number, string> = {
  1: '230px',
  2: '230px',
  3: '230px',
  4: '190px',
  5: '160px',
  6: '160px',
  7: '160px',
};
